export const appPageTransition = {"name":"blur","mode":"default"}

export const appLayoutTransition = {"name":"blur","mode":"default"}

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, viewport-fit=cover, maximum-scale=1"},{"name":"msapplication-TileColor","content":"#07133b"},{"name":"theme-color","content":"#ffffff"},{"name":"description","content":"Smarte Rotationsplanung für Kliniken"},{"property":"og:site_name","content":"SEDIWORK"},{"property":"og:type","content":"website"},{"property":"og:url","content":"https://sediwork.de/"},{"property":"og:image:secure_url","content":"https://sediwork.de/icon.png"},{"property":"og:title","content":"SEDIWORK"},{"property":"og:description","content":"Smarte Rotationsplanung für Kliniken"},{"property":"og:image","content":"https://sediwork.de/icon.png"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:url","content":"https://sediwork.de/"},{"name":"twitter:title","content":"SEDIWORK"},{"name":"twitter:description","content":"Smarte Rotationsplanung für Kliniken"},{"name":"twitter:image","content":"https://sediwork.de/icon.png"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"canonical","href":"https://sediwork.de/"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-16x16.png"},{"rel":"manifest","href":"/site.webmanifest"},{"rel":"mask-icon","href":"/safari-pinned-tab.svg","color":"#07133b"}],"style":[],"script":[],"noscript":[],"title":"Digitale Rotationsplanung","titleTemplate":"%s - SEDIWORK"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true